package com.eladfinish.bible.contest

import androidx.compose.runtime.staticCompositionLocalOf

interface AppActions {
    fun restartApp()
    fun exitApp()
    fun clearApplicationData()
    fun checkUpdate()
    fun rateApp()
    fun openAppStore()
    fun upgrade()
    fun showAd()
    fun showRewardedAd()
    fun startRemoveAdsPurchase()
    fun restorePurchase()
    fun consumeTestPurchase()
    fun onMikudLongClicked()
    fun onSettingsLongClicked()
    fun onBrowseLongClicked()
    fun onAboutLongClicked()
}

val LocalAppActions = staticCompositionLocalOf<AppActions> {
    error("LocalAppActions not provided — wrap your root composable with CompositionLocalProvider(LocalAppActions provides ...)")
}
